import styled from "styled-components";
import { registrationScrollBodyStyles } from "../RegistrationLayout/registrationScrollBodyStyles";
import { registrationFormStyles } from "../RegistrationLayout/registrationFormStyles";
import {
  REGISTRATION_FOCUS_RING,
  REGISTRATION_FONT_BODY,
  REGISTRATION_FOREST,
  REGISTRATION_LINK,
  REGISTRATION_ON_PRIMARY,
  REGISTRATION_PRIMARY,
  REGISTRATION_PRIMARY_DARK,
} from "../RegistrationLayout/registrationTheme";

const WelcomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: transparent;
  font-family: ${REGISTRATION_FONT_BODY};

  .scroll-body {
    ${registrationScrollBodyStyles}
  }

  .content-card-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 32px 20px;
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    @media (min-width: 600px) {
      padding: 32px 32px;
    }
  }

  .hero-section {
    text-align: center;
    padding: 12px 0 36px;

    .section-eyebrow {
      font-size: 10px;
      margin-bottom: 6px;
    }

    .section-title {
      font-size: 20px;
      margin-bottom: 8px;

      @media (min-width: 600px) {
        font-size: 24px;
      }
    }

    .section-sub {
      font-size: 13px;
    }
  }

  .hero-icon-wrap {
    width: 60px;
    height: 60px;
    margin: 0 auto 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hero-icon {
    width: 60px;
    height: 60px;
    object-fit: contain;
  }

  .hero-section .section-sub {
    margin-bottom: 0;
  }

  .feature-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 32px;
  }

  .feature-item {
    display: flex;
    gap: 14px;
    align-items: flex-start;
  }

  .feature-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(174, 206, 56, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 15px;
  }

  .feature-title {
    font-size: 14px;
    font-weight: 600;
    color: #5a6b80;
    margin-bottom: 2px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .feature-desc {
    font-size: 12px;
    color: ${REGISTRATION_FOREST};
    line-height: 1.5;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .get-started-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 16px 32px;
    border-radius: 999px;
    border: none;
    background: ${REGISTRATION_PRIMARY};
    color: ${REGISTRATION_ON_PRIMARY};
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-top: 8px;

    &:hover {
      background: ${REGISTRATION_PRIMARY_DARK};
      color: ${REGISTRATION_ON_PRIMARY};
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(174, 206, 56, 0.35);
    }

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
    }
  }

  .footer-section {
    text-align: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid rgba(30, 42, 53, 0.08);
  }

  .footer-text {
    font-size: 13px;
    font-weight: 600;
    color: ${REGISTRATION_LINK};
    margin-bottom: 14px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .app-icon {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;

    a {
      display: inline-flex;
    }

    img {
      height: 40px;
      width: auto;
      cursor: pointer;
    }
  }

  .store-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #000;
    color: #fff;
    border-radius: 10px;
    padding: 10px 16px;
    text-decoration: none;
    transition: opacity 0.2s;

    &:hover,
    &:focus {
      color: #fff;
      text-decoration: none;
      opacity: 0.9;
    }
  }

  .store-btn-label {
    text-align: left;
    line-height: 1.2;
  }

  .store-btn-eyebrow {
    font-size: 9px;
    font-weight: 400;
    opacity: 0.75;
    font-family: ${REGISTRATION_FONT_BODY};
    letter-spacing: 0.2px;
  }

  .store-btn-title {
    font-size: 14px;
    font-weight: 700;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  ${registrationFormStyles}

  .notice-box.notice-box-privacy {
    background: rgba(90, 107, 128, 0.07);
    border: 1px solid rgba(90, 107, 128, 0.15);
    margin-bottom: 24px;
  }
`;

export default WelcomeWrapper;
